import { useQuery } from "@apollo/client/react"
import React, { useContext, createContext, useMemo } from "react"

import { GetFeatureFlagsDocument, type GetFeatureFlagsQuery } from "@/graphql/graphql"

type FeatureFlagsContextValue = {
  customSectionsEnabled: boolean
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue | null>(null)

export function useFeatureFlags() {
  const ctx = useContext(FeatureFlagsContext)
  if (!ctx) throw new Error("useFeatureFlags must be used within FeatureFlagsProvider")
  return ctx
}

export function FeatureFlagsProvider({ children }: { children: React.ReactNode }) {
  const { data } = useQuery<GetFeatureFlagsQuery>(GetFeatureFlagsDocument)

  const value = useMemo<FeatureFlagsContextValue>(
    () => ({
      customSectionsEnabled: data?.featureFlags?.customSectionsEnabled ?? false,
    }),
    [data],
  )

  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>
}
